import { useIsFollowedThemesEnabled } from '@terminal/hooks/use-is-followed-themes-enabled/useIsFollowedThemesEnabled';
import {
  useRemoteStorage,
  type WatchlistSelection,
  WHATS_NEW_INCLUDE_COMPETITORS,
  WHATS_NEW_PERIOD,
  WHATS_NEW_SELECTED_WATCHLISTS,
} from '@terminal/hooks/use-remote-storage';
import { useInsightFeedFilters } from '@terminal/stores/use-insight-feed-filters/useInsightFeedFilters';

import type { InsightsPeriod } from '../types';
import { DEFAULT_WHATS_NEW_PERIOD } from '../types';

export type WhatsNewSettings = {
  selectedWatchlists: WatchlistSelection[] | undefined;
  period: InsightsPeriod;
  includeCompetitors: boolean | undefined;
};

export const useWhatsNewSettings = (): WhatsNewSettings => {
  const isFollowedThemesEnabled = useIsFollowedThemesEnabled();
  const items = useRemoteStorage(state => state.items);

  const { selectedWatchlistIds, isSecondRelationshipEnabled } =
    useInsightFeedFilters(state => ({
      selectedWatchlistIds: state.selectedWatchlistIds,
      isSecondRelationshipEnabled: state.isSecondRelationshipEnabled,
    }));

  const period = items?.[WHATS_NEW_PERIOD] ?? DEFAULT_WHATS_NEW_PERIOD;

  if (isFollowedThemesEnabled) {
    return {
      selectedWatchlists:
        selectedWatchlistIds.size > 0
          ? Array.from(selectedWatchlistIds).map(id => ({ id }))
          : undefined,
      period,
      includeCompetitors: isSecondRelationshipEnabled,
    };
  }

  return {
    selectedWatchlists: items?.[WHATS_NEW_SELECTED_WATCHLISTS],
    period,
    includeCompetitors: items?.[WHATS_NEW_INCLUDE_COMPETITORS],
  };
};
